import { render, staticRenderFns } from "./gardener.vue?vue&type=template&id=08096e2e"
import script from "./gardener.vue?vue&type=script&lang=js"
export * from "./gardener.vue?vue&type=script&lang=js"
import style0 from "./gardener.vue?vue&type=style&index=0&id=08096e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports